export interface IAppConfigType {
    clientID: string;
    authority: string;
    authorityResetPassword: string;
    b2cScopes: string[];
    b2cResetPasswordUri: string;
    redirectURI: string;
}

export interface ILegalClusterConfigType {
    applicationConfig: IAppConfigType;
    apimSubscriptionKey: string;
    signalRUri: string;
    notificationUrl: string;
    organizationsApi: string;
    clustersApi: string;
    messagingApi: string;
    permissionsApi: string;
    profilesApi: string;
    validationsApi: string;
    languageApi: string;
    uriCommonApi: string;
    pdfViewerApi: string;
    searchArticlesUrl: string;
    legalDocApi: string;
    environment: string;
    defaultLanguage: string;
    platform: ELegalClusterEnv;
    isLocalHost: boolean;
    isWopiIntegrationActive: boolean;
    appInsights: { instrumentationKey: string };
    smh?: { trackingUrl: string; trackingId: string };
    isRegistrationFinalScreenActive: boolean;
}

export enum ELegalClusterEnv {
    lcProd = 'legalcluster-prod',
    lcDemo = 'legalcluster-demo',
    lcDev = 'legalcluster-dev',
    lcRec = 'legalcluster-rec'
}

export interface ITheme {
    colors: { primary: string; secondary: string };
    font: { primary: string; secondary: string };
    fontImport: string;
    normBooks?: 'colors' | 'images';
}
